import { array, addMethod } from 'yup';
import IBAN from 'iban';

export default () => {
  // eslint-disable-next-line func-names
  addMethod(array, 'validIBAN', function () {
    return this.test({
      name: 'validIBAN',
      message: 'IBAN numbers are not valid',
      test: (values = []) => {
        const ibanNumbers = values.map(value => value.iban);

        if (!ibanNumbers || ibanNumbers.length === 0) {
          return true;
        }

        return ibanNumbers.every(ibanNumber => IBAN.isValid(ibanNumber));
      },
    });
  });
};
